module.exports = __webpack_public_path__ + "static/media/time.e750aacf.svg";